import { compose, hoistStatics, pure } from 'recompose';
import ButtonFilter from './buttonFilter';

const enhancer = compose(
  pure,
  hoistStatics,
);

export default enhancer(ButtonFilter);
